import {store} from '../../store'
import {httpgst} from '../../main'

const state = {}

const getters = {}

const actions = {
  get ({commit, dispatch}, payload) {
    let params = {
      'user_id': payload.event.context.userLogged.id,
      'project_id': payload.event.context.selectedProject !== null && payload.event.context.selectedProject !== -1 ? payload.event.context.selectedProject : undefined,
      'status_id': payload.event.context.selectedStatus !== null && payload.event.context.selectedStatus !== -1 ? payload.event.context.selectedStatus : undefined,
      'employee_id': payload.event.context.userCompanySelected !== null && payload.event.context.userCompanySelected !== -1 ? payload.event.context.userCompanySelected : undefined,
      'date_start': payload.event.context.startDate !== null ? payload.event.context.startDate : undefined,
      'date_end': payload.event.context.endDate !== null ? payload.event.context.endDate : undefined,
      'type': payload.event.context.type,
      'perPage': payload.event.context.pagination.rowsPerPage,
      'page': payload.event.context.pagination.page
      
    }
    let url = `api/reports/master`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params }, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  downloadFile ({commit, dispatch}, payload) {
    let params = {
      'user_id': payload.event.context.userLogged.id,
      'project_id': payload.event.context.selectedProject !== null && payload.event.context.selectedProject !== -1 ? payload.event.context.selectedProject : undefined,
      'status_id': payload.event.context.selectedStatus !== null  && payload.event.context.selectedStatus !== -1 ? payload.event.context.selectedStatus : undefined,
      'employee_id': payload.event.context.userCompanySelected !== null && payload.event.context.userCompanySelected !== -1  ? payload.event.context.userCompanySelected : undefined,
      'date_start': payload.event.context.startDate !== null ? payload.event.context.startDate : undefined,
      'date_end': payload.event.context.endDate !== null ? payload.event.context.endDate : undefined,
      'type': payload.event.context.type
    }
    let url = `api/reports/master`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {responseType: 'blob', params}, options)
      .then(
        response => {
          commit('onDownloadReport', {event: payload.event, response: response})
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  }
}

const mutations = {
  onGet (state, payload) {
    // let expenses = []
    const responseExpenses = Object.assign({}, payload.response.data.data.reportData.expenses)
    // const listExpenses = Object.getOwnPropertyNames(responseExpenses)
    // listExpenses.forEach(i => {
    //   let el = responseExpenses[i]
    //   el = {
    //     ...el
    //   }
    //   expenses.push(el)
    // })
    payload.event.context.expenses = responseExpenses.data
    payload.event.context.pagination.rowsPerPage = parseInt(payload.response.data.data.reportData.expenses.per_page)
    payload.event.context.pagination.page = payload.response.data.data.reportData.expenses.current_page
    payload.event.context.pagination.totalItems = payload.response.data.data.reportData.expenses.total
    payload.event.context.pagination.lastPage = payload.response.data.data.reportData.expenses.last_page
    payload.event.context.show = true
    payload.event.context.disabled = false
    payload.event.context.loading = false
    payload.event.context.dialog = false
    payload.event.context.loadingItems = false
  },
  onDownloadReport (state, payload) {
    let date = payload.event.context.getReportDate()
    payload.event.context.forceFileDownload(payload.response.data, `ReportExpenseTracking ${payload.event.context.year} ${date}.xlsx`)
    payload.event.context.loadingDownload = false
  },
  onError (state, payload) {
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.loadingDownload = false
    payload.event.context.disabled = false
    payload.event.context.loadingItems = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reportExpenseTracking.js